import { render, staticRenderFns } from "./feeDetailTable.vue?vue&type=template&id=2abfceb1&scoped=true"
import script from "./feeDetailTable.vue?vue&type=script&lang=js"
export * from "./feeDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abfceb1",
  null
  
)

export default component.exports